import { DeviceCurrentValue, DeviceDataChart, DeviceSelection, DeviceAssistantPanel } from "@entities/devices";
import { devicesEntity } from '@entities/devices';
import { useUnit } from "effector-react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { sensorRecordingModel } from '../../features/sensor/recoring';
import { exportSensorDataModel } from '../../features/sensor/export-data';
import { askAiModel } from '../../features/sensor/ask-ai';
import { BluetoothConnect, bluetoothConnectModel } from '../../features/bluetooth/connect-device';

import '../../features/sensorium/connect';
import '../../features/labmate/connect';

export const HomePage = () => {
  const { t } = useTranslation();
  const [connectedDevice, deviceInfo] = useUnit([
    devicesEntity.$connectedDevice,
    devicesEntity.$deviceInfo,
  ]);

  const [lastValue, stats, tableData, chartData] = useUnit([
    devicesEntity.$lastValue,
    devicesEntity.$stats,
    devicesEntity.$tableData,
    devicesEntity.$chartData,
  ]);

  const [isRecording, startRecording, stopRecording, resetRecording] = useUnit([
    sensorRecordingModel.$isRecording,
    sensorRecordingModel.startRecording,
    sensorRecordingModel.stopRecording,
    sensorRecordingModel.resetRecording
  ]);

  const [frequency, setFrequency] = useUnit([
    devicesEntity.$frequency,
    devicesEntity.setFrequency
  ]);

  const [exportRecording] = useUnit([
    exportSensorDataModel.exportData
  ]);

  const [messages, isAiThinking] = useUnit([
    askAiModel.$history,
    askAiModel.$pending,
  ]);

  const [disconnectBluetooth] = useUnit([bluetoothConnectModel.disconnectCurrentDevice]);

  return (
    <div className="min-h-screen flex flex-col">
      {!connectedDevice && <BluetoothConnect />}

      {connectedDevice && !deviceInfo && (
        <DeviceSelection onDeviceSelect={device => devicesEntity.setDeviceInfo({ ...device, mode: "usb" })} />
      )}

      {connectedDevice && deviceInfo && (
        <>
          <main className="flex-1 w-full container mx-auto px-4 py-8 lg:py-10 max-w-9xl">
            {deviceInfo && (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                className="space-y-8"
              >
                {/* 50/50: слева Value + Chart (column), справа Chat. Высота чата = высоте левой колонки */}
                <div className="grid grid-cols-1 xl:grid-cols-2 gap-8 items-stretch">
                  <div className="min-w-0 flex flex-col gap-8">
                    <DeviceCurrentValue
                      deviceMode={deviceInfo.mode}
                      hasData={tableData.length > 0}
                      onFrequencyChange={setFrequency}
                      pollingFrequency={frequency}
                      value={lastValue}
                      unit={deviceInfo.unit}
                      deviceName={deviceInfo.name}
                      isRecording={isRecording}
                      onDisconnect={disconnectBluetooth}
                      onStart={startRecording}
                      onResume={startRecording}
                      onFinish={stopRecording}
                      onReset={resetRecording}
                      onExport={exportRecording}
                      stats={stats}
                    />
                    <DeviceDataChart
                      title={t('chart.title')}
                      labels={chartData.labels}
                      values={chartData.values}
                      unit={deviceInfo.unit}
                    />
                  </div>
                  <div
                    className="min-w-0 min-h-0 flex w-full overflow-hidden"
                    style={{ contain: "size" }}
                  >
                    <DeviceAssistantPanel
                      className="w-full !h-full !min-h-0 !max-h-full"
                      thinking={isAiThinking}
                      messages={messages}
                      onSubmit={askAiModel.askQuestion}
                      onReset={askAiModel.reset}
                    />
                  </div>
                </div>
              </motion.div>
            )}
          </main>

          <footer className="text-center text-gray-500 text-sm py-6 border-t border-gray-800">
            <p>{t('home.footer', { year: new Date().getFullYear() })}</p>
          </footer>
        </>
      )}
    </div>
  );
};
